import * as actions from './actions'
import { DEFAUL_DEVICES_TAKE } from './constants'

const initState = {
    isLoading: null,
    isLoadingMore: null,
    devices: null,
    device: null,
    sharedUsers: null,
    deviceReports: null,
    skip: 0,
    deviceImages: {},
    deviceImagesLoader: false
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.SET_DEVICES:
            return {
                ...state,
                ...{
                    devices: action.devices
                }
            }
        case actions.START_LOADING:
            return {
                ...state,
                ...{
                    isLoading: true
                }
            }
        case actions.DEVICES_REQUEST:
            return {
                ...state,
                ...{
                    skip: 0
                }
            }
        case actions.DEVICES_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    isLoading: false,
                    devices: action.devices,
                    skip: action.devices?.length
                        ? state.skip + DEFAUL_DEVICES_TAKE
                        : state.skip
                }
            }
        case actions.DEVICE_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    device: action.device
                }
            }
        case actions.DEVICE_REPORTS_SUCCESS:
            return {
                ...state,
                ...{
                    deviceReports: action.deviceReports
                }
            }
        case actions.SHARED_USERS_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    sharedUsers: action.sharedUsers
                }
            }
        case actions.FETCH_MORE_DEVICES:
            return {
                ...state,
                isLoadingMore: true
            }
        case actions.DEVICES_REQUEST_MORE_SUCCESS:
            return {
                ...state,
                isLoadingMore: false,
                devices: action.devices.length
                    ? [...state.devices, ...action.devices]
                    : [...state.devices],
                skip: action.devices.length
                    ? state.skip + DEFAUL_DEVICES_TAKE
                    : state.skip
            }
        case actions.DEVICES_REQUEST_MORE_ERROR:
            return {
                ...state,
                isLoadingMore: false
            }

        case actions.SET_IMAGES_FOR_DEVICES:
            return {
                ...state,
                ...{
                    deviceImages: {
                        ...state.deviceImages,
                        ...action.images
                    }
                }
            }
        case actions.SET_DEVICE_IMAGES_LOADER:
            return {
                ...state,
                deviceImagesLoader: action.loading
            }
        default:
            return state
    }
}
